import React from "react";
const KS2Intro = () => {
  return (
    <div className="row">
    <div style={{ padding: "10px", paddingTop: "10px" }}>
      <p className="fontsize-18 mb-0">Use this form to provide your details to your employer if you are:</p>
      <ul className="fontsize-18">
        <li className="pl-2">starting new employment </li>
        <li className="pl-2">an existing employee and want to opt into KiwiSaver </li>
        <li className="pl-2">a KiwiSaver member and want to change your contribution rate.</li>
      </ul>
      <p className="fontsize-18 mb-0">To be eligible to join KiwiSaver you must:</p>
      <ul className="fontsize-18">
        <li className="pl-2">Live, or normally live in New Zealand, and </li>
        <li className="pl-2">be a New Zealand citizen, or entitled to stay in New Zealand indefinitely.</li>
      </ul>
      <p className="fontsize-18 mb-2">You are not required to be auto enrolled when starting a new job if you are under the age of 18 or you are over the age of eligibility for New Zealand Superannuation (currently 65). </p>
      <p className="fontsize-18">
        <strong>Please read the notes on the back to help you fill in this form</strong>
      </p>
    </div>
  </div>
  )
}

export default KS2Intro;